export default __webpack_public_path__ + "static/media/whatsapp-notice-2.95861878.webp";